import React from 'react';
import styled from 'styled-components';
import { mobileMediaQuery, themeColor } from '../../../Theming';
import { SvgProps } from '../core';

const StyledSVG = styled.svg`
  color: ${themeColor('darkBlue')};
  ${mobileMediaQuery} {
    margin-left: 25px;
    width: 105.16px;
    height: 112.19px;
  }
`;

const BenefitOne: React.FC<SvgProps> = ({
  width = 156,
  height = 159,
  className,
}) => {
  return (
    <StyledSVG
      width={width}
      height={height}
      className={className}
      viewBox="0 0 156 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M55.9476 96.2212C55.9476 102.179 65.5895 106.956 77.5299 106.956C89.4141 106.956 99.1121 102.123 99.1121 96.2212C99.1121 90.2636 89.4702 85.4863 77.5299 85.4863C65.5895 85.4863 55.9476 90.3198 55.9476 96.2212Z"
        fill="currentColor"
      />
      <path
        d="M77.4737 112.577C87.7883 112.577 96.3652 108.98 98.4954 104.146C98.8317 104.877 98.9999 105.664 98.9999 106.451C98.9999 112.408 89.3579 117.186 77.4176 117.186C65.5333 117.186 55.8353 112.352 55.8353 106.451C55.8353 105.664 56.0035 104.877 56.3398 104.146C58.5822 108.98 67.2151 112.577 77.4737 112.577Z"
        fill="currentColor"
      />
      <path
        d="M77.4737 122.974C87.7883 122.974 96.3652 119.376 98.4954 114.543C98.8317 115.274 98.9999 116.06 98.9999 116.847C98.9999 122.805 89.3579 127.582 77.4176 127.582C65.5333 127.582 55.8353 122.749 55.8353 116.847C55.8353 116.06 56.0035 115.274 56.3398 114.543C58.5822 119.376 67.2151 122.974 77.4737 122.974Z"
        fill="currentColor"
      />
      <path
        d="M77.4737 133.429C87.7883 133.429 96.3652 129.832 98.4954 124.998C98.8317 125.729 98.9999 126.516 98.9999 127.302C98.9999 133.26 89.3579 138.037 77.4176 138.037C65.5333 138.037 55.8353 133.204 55.8353 127.302C55.8353 126.516 56.0035 125.729 56.3398 124.998C58.5822 129.832 67.2151 133.429 77.4737 133.429Z"
        fill="currentColor"
      />
      <path
        d="M77.4737 143.882C87.7883 143.882 96.3652 140.285 98.4954 135.451C98.8317 136.182 98.9999 136.969 98.9999 137.756C98.9999 143.713 89.3579 148.49 77.4176 148.49C65.5333 148.49 55.8353 143.657 55.8353 137.756C55.8353 136.969 56.0035 136.182 56.3398 135.451C58.5822 140.285 67.2151 143.882 77.4737 143.882Z"
        fill="currentColor"
      />
      <path
        d="M77.4737 154.335C87.7883 154.335 96.3652 150.738 98.4954 145.904C98.8317 146.635 98.9999 147.422 98.9999 148.209C98.9999 154.166 89.3579 158.944 77.4176 158.944C65.5333 158.944 55.8353 154.11 55.8353 148.209C55.8353 147.422 56.0035 146.635 56.3398 145.904C58.5822 150.738 67.2151 154.335 77.4737 154.335Z"
        fill="currentColor"
      />
      <path
        d="M110.66 65.8716C110.66 71.8292 120.302 76.6065 132.242 76.6065C144.127 76.6065 153.825 71.773 153.825 65.8716C153.825 59.914 144.183 55.1367 132.242 55.1367C120.302 55.1367 110.66 59.9702 110.66 65.8716Z"
        fill="currentColor"
      />
      <path
        d="M132.242 82.2274C142.557 82.2274 151.134 78.6304 153.264 73.7969C153.6 74.5275 153.769 75.3144 153.769 76.1012C153.769 82.0588 144.127 86.8361 132.186 86.8361C120.302 86.8361 110.604 82.0026 110.604 76.1012C110.604 75.3144 110.772 74.5275 111.109 73.7969C113.295 78.6304 121.928 82.2274 132.242 82.2274Z"
        fill="currentColor"
      />
      <path
        d="M132.242 92.6239C142.557 92.6239 151.134 89.0269 153.264 84.1934C153.6 84.924 153.769 85.7109 153.769 86.4977C153.769 92.4553 144.127 97.2326 132.186 97.2326C120.302 97.2326 110.604 92.3991 110.604 86.4977C110.604 85.7109 110.772 84.924 111.109 84.1934C113.295 89.0269 121.928 92.6239 132.242 92.6239Z"
        fill="currentColor"
      />
      <path
        d="M132.242 103.079C142.557 103.079 151.134 99.4819 153.264 94.6484C153.6 95.3791 153.769 96.1659 153.769 96.9528C153.769 102.91 144.127 107.688 132.186 107.688C120.302 107.688 110.604 102.854 110.604 96.9528C110.604 96.1659 110.772 95.3791 111.109 94.6484C113.295 99.4819 121.928 103.079 132.242 103.079Z"
        fill="currentColor"
      />
      <path
        d="M132.242 113.532C142.557 113.532 151.134 109.935 153.264 105.102C153.6 105.832 153.769 106.619 153.769 107.406C153.769 113.363 144.127 118.141 132.186 118.141C120.302 118.141 110.604 113.307 110.604 107.406C110.604 106.619 110.772 105.832 111.109 105.102C113.295 109.935 121.928 113.532 132.242 113.532Z"
        fill="currentColor"
      />
      <path
        d="M132.242 123.985C142.557 123.985 151.134 120.388 153.264 115.555C153.6 116.285 153.769 117.072 153.769 117.859C153.769 123.817 144.127 128.594 132.186 128.594C120.302 128.594 110.604 123.76 110.604 117.859C110.604 117.072 110.772 116.285 111.109 115.555C113.295 120.388 121.928 123.985 132.242 123.985Z"
        fill="currentColor"
      />
      <path
        d="M132.242 133.821C142.557 133.821 151.134 130.224 153.264 125.391C153.6 126.121 153.769 126.908 153.769 127.695C153.769 133.653 144.127 138.43 132.186 138.43C120.302 138.43 110.604 133.596 110.604 127.695C110.604 126.908 110.772 126.121 111.109 125.391C113.295 130.168 121.928 133.821 132.242 133.821Z"
        fill="currentColor"
      />
      <path
        d="M132.242 143.6C142.557 143.6 151.134 140.003 153.264 135.17C153.6 135.901 153.769 136.687 153.769 137.474C153.769 143.432 144.127 148.209 132.186 148.209C120.302 148.209 110.604 143.376 110.604 137.474C110.604 136.687 110.772 135.901 111.109 135.17C113.295 140.003 121.928 143.6 132.242 143.6Z"
        fill="currentColor"
      />
      <path
        d="M132.242 153.436C142.557 153.436 151.134 149.839 153.264 145.006C153.6 145.737 153.769 146.523 153.769 147.31C153.769 153.268 144.127 158.045 132.186 158.045C120.302 158.045 110.604 153.212 110.604 147.31C110.604 146.523 110.772 145.737 111.109 145.006C113.295 149.839 121.928 153.436 132.242 153.436Z"
        fill="currentColor"
      />
      <path
        d="M2.91677 116.286C2.91677 122.243 12.5587 127.021 24.499 127.021C36.3833 127.021 46.0813 122.187 46.0813 116.286C46.0813 110.328 36.4394 105.551 24.499 105.551C12.5587 105.551 2.91677 110.328 2.91677 116.286Z"
        fill="currentColor"
      />
      <path
        d="M24.499 132.585C34.8136 132.585 43.3905 128.988 45.5207 124.154C45.857 124.885 46.0252 125.672 46.0252 126.459C46.0252 132.416 36.3832 137.194 24.4429 137.194C12.5586 137.194 2.86063 132.36 2.86063 126.459C2.86063 125.672 3.0288 124.885 3.36515 124.154C5.5514 128.988 14.1843 132.585 24.499 132.585Z"
        fill="currentColor"
      />
      <path
        d="M24.499 143.04C34.8136 143.04 43.3905 139.443 45.5207 134.609C45.857 135.34 46.0252 136.127 46.0252 136.914C46.0252 142.871 36.3832 147.649 24.4429 147.649C12.5586 147.649 2.86063 142.815 2.86063 136.914C2.86063 136.127 3.0288 135.34 3.36515 134.609C5.5514 139.443 14.1843 143.04 24.499 143.04Z"
        fill="currentColor"
      />
      <path
        d="M24.499 153.493C34.8136 153.493 43.3905 149.896 45.5207 145.062C45.857 145.793 46.0252 146.58 46.0252 147.367C46.0252 153.324 36.3832 158.102 24.4429 158.102C12.5586 158.102 2.86063 153.268 2.86063 147.367C2.86063 146.58 3.0288 145.793 3.36515 145.062C5.5514 149.896 14.1843 153.493 24.499 153.493Z"
        fill="currentColor"
      />
      <path
        d="M125.459 0L113.855 10.4539L138.521 12.0838L76.8009 56.878L25.8443 56.6532L0.00158691 80.0339V91.0498C0.0576448 90.9936 0.113703 90.9374 0.169761 90.8812L27.9745 65.8144L78.6508 65.983L143.117 18.8844L142.22 42.0965L153.824 31.6426L155.002 2.02333L125.459 0Z"
        fill="currentColor"
      />
    </StyledSVG>
  );
};

export default BenefitOne;
